"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomToolbar = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _PageContext = require("../../context/PageContext");
var _BottomToolbarContext = require("../../context/BottomToolbarContext");
var _navigationDrawer = require("../navigation/navigation-drawer");
var _chatBubbleOutline = _interopRequireDefault(require("../../../assets/chat-bubble-outline.svg"));
var _libraryBooks = _interopRequireDefault(require("../../../assets/library-books.svg"));
var _list_alt = _interopRequireDefault(require("../../../assets/list_alt.svg"));
var _Menu = _interopRequireDefault(require("../../../assets/Menu.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var NAV_STORAGE_KEY = "dioptra-nav-expanded";
var BottomToolbar = exports.BottomToolbar = function BottomToolbar() {
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage,
    currentPage = _usePage.currentPage;
  var _useBottomToolbar = (0, _BottomToolbarContext.useBottomToolbar)(),
    actionSlot = _useBottomToolbar.actionSlot;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isSidebarOpen = _React$useState2[0],
    setIsSidebarOpen = _React$useState2[1];
  var _React$useState3 = React.useState(function () {
      return localStorage.getItem(NAV_STORAGE_KEY) === "true";
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isNavExpanded = _React$useState4[0],
    setIsNavExpanded = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isCollapsing = _React$useState6[0],
    setIsCollapsing = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    hoveredPill = _React$useState8[0],
    setHoveredPill = _React$useState8[1];
  var hoverTimeoutRef = React.useRef(null);
  var collapseTimeoutRef = React.useRef(null);
  var handlePillEnter = function handlePillEnter(pill) {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    setHoveredPill(pill);
  };
  var handlePillLeave = function handlePillLeave() {
    hoverTimeoutRef.current = setTimeout(function () {
      return setHoveredPill(null);
    }, 300);
  };
  var cancelCollapse = function cancelCollapse() {
    if (collapseTimeoutRef.current) {
      clearTimeout(collapseTimeoutRef.current);
      collapseTimeoutRef.current = null;
    }
    setIsCollapsing(false);
  };
  React.useEffect(function () {
    return function () {
      if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
      if (collapseTimeoutRef.current) clearTimeout(collapseTimeoutRef.current);
    };
  }, []);
  var isChatActive = currentPage === _PageContext.PAGES.chatPage || currentPage === _PageContext.PAGES.chatHistoryPage;
  var isPlaybooksActive = currentPage === _PageContext.PAGES.myPlaybooksPage || currentPage === _PageContext.PAGES.playbookPage || currentPage === _PageContext.PAGES.submitDocumentPage || currentPage === _PageContext.PAGES.documentReviewPage || currentPage === _PageContext.PAGES.reviewConfirmationPage || currentPage === _PageContext.PAGES.ruleDetailsPage || currentPage === _PageContext.PAGES.recentRunsPage;
  var isLibraryActive = currentPage === _PageContext.PAGES.libraryPage || currentPage === _PageContext.PAGES.clausePage;
  var activeSection = isChatActive ? "chat" : isPlaybooksActive ? "playbooks" : isLibraryActive ? "library" : "more";
  var activeSectionIcon = activeSection === "chat" ? _chatBubbleOutline.default : activeSection === "playbooks" ? _libraryBooks.default : activeSection === "library" ? _list_alt.default : _Menu.default;
  var activeSectionLabel = activeSection === "chat" ? "Chat" : activeSection === "playbooks" ? "Playbooks" : activeSection === "library" ? "Library" : "More";
  var expandNav = function expandNav() {
    cancelCollapse();
    setIsNavExpanded(true);
    localStorage.setItem(NAV_STORAGE_KEY, "true");
  };
  var collapseNav = function collapseNav() {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    setHoveredPill(null);
    setIsCollapsing(true);
    collapseTimeoutRef.current = setTimeout(function () {
      setIsNavExpanded(false);
      setIsCollapsing(false);
      localStorage.setItem(NAV_STORAGE_KEY, "false");
    }, 300);
  };
  var handleChatClick = function handleChatClick() {
    setIsSidebarOpen(false);
    showPage(_PageContext.PAGES.chatPage);
    expandNav();
  };
  var handlePlaybooksClick = function handlePlaybooksClick() {
    setIsSidebarOpen(false);
    showPage(_PageContext.PAGES.submitDocumentPage);
    expandNav();
  };
  var handleLibraryClick = function handleLibraryClick() {
    setIsSidebarOpen(false);
    showPage(_PageContext.PAGES.libraryPage, {
      activeTab: "prompts"
    });
    expandNav();
  };
  var handleMoreClick = function handleMoreClick() {
    setIsSidebarOpen(!isSidebarOpen);
    expandNav();
  };
  var pillCls = function pillCls(pill) {
    var collapsing = isCollapsing && activeSection !== pill;
    return (0, _utils.cn)("relative flex items-center justify-center", "h-8 rounded-full cursor-pointer overflow-hidden whitespace-nowrap", "transition-[width,padding,background-color,box-shadow,opacity] duration-300 ease-out", "focus:outline-none focus:ring-2 focus:ring-[var(--primary)]", collapsing ? "w-0 px-0 opacity-0" : hoveredPill === pill ? "w-[108px] px-2" : "w-8 px-0");
  };
  var labelCls = function labelCls(pill) {
    return (0, _utils.cn)("text-xs font-medium overflow-hidden transition-[max-width,opacity,margin] duration-300 ease-out", hoveredPill === pill ? "max-w-[72px] opacity-100 ml-1 delay-75" : "max-w-0 opacity-0 delay-0");
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      "data-component": "bottom-toolbar",
      className: "flex-none flex items-center justify-between border-t border-gray-100 bg-white px-3 py-1",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex items-center",
        children: actionSlot !== null && actionSlot !== void 0 ? actionSlot : null
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex items-center",
        children: isNavExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex items-center",
          onMouseEnter: cancelCollapse,
          onMouseLeave: collapseNav,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            onClick: handleChatClick,
            onMouseEnter: function onMouseEnter() {
              return handlePillEnter('chat');
            },
            onMouseLeave: handlePillLeave,
            className: (0, _utils.cn)(pillCls('chat'), isChatActive ? (0, _utils.cn)("bg-[var(--primary)] text-white", hoveredPill === 'chat' && "bg-[var(--background-primary-hover)]") : (0, _utils.cn)("text-gray-600", hoveredPill === 'chat' && "bg-[var(--primary)]/10")),
            "aria-label": "Chat",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _chatBubbleOutline.default,
              alt: "",
              className: "w-4 h-4 flex-none pointer-events-none transition-[filter] duration-200",
              style: {
                filter: isChatActive ? "brightness(0) invert(1)" : "brightness(0)"
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: labelCls('chat'),
              children: "Chat"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            onClick: handlePlaybooksClick,
            onMouseEnter: function onMouseEnter() {
              return handlePillEnter('playbooks');
            },
            onMouseLeave: handlePillLeave,
            className: (0, _utils.cn)(pillCls('playbooks'), isPlaybooksActive ? (0, _utils.cn)("bg-[var(--primary)] text-white", hoveredPill === 'playbooks' && "bg-[var(--background-primary-hover)]") : (0, _utils.cn)("text-gray-600", hoveredPill === 'playbooks' && "bg-[var(--primary)]/10")),
            "aria-label": "Playbooks",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _libraryBooks.default,
              alt: "",
              className: "w-4 h-4 flex-none pointer-events-none transition-[filter] duration-200",
              style: {
                filter: isPlaybooksActive ? "brightness(0) invert(1)" : "brightness(0)"
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: labelCls('playbooks'),
              children: "Playbooks"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            onClick: handleLibraryClick,
            onMouseEnter: function onMouseEnter() {
              return handlePillEnter('library');
            },
            onMouseLeave: handlePillLeave,
            className: (0, _utils.cn)(pillCls('library'), isLibraryActive ? (0, _utils.cn)("bg-[var(--primary)] text-white", hoveredPill === 'library' && "bg-[var(--background-primary-hover)]") : (0, _utils.cn)("text-gray-600", hoveredPill === 'library' && "bg-[var(--primary)]/10")),
            "aria-label": "Library",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _list_alt.default,
              alt: "",
              className: "w-4 h-4 flex-none pointer-events-none transition-[filter] duration-200",
              style: {
                filter: isLibraryActive ? "brightness(0) invert(1)" : "brightness(0)"
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: labelCls('library'),
              children: "Library"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            onClick: handleMoreClick,
            onMouseEnter: function onMouseEnter() {
              return handlePillEnter('more');
            },
            onMouseLeave: handlePillLeave,
            className: (0, _utils.cn)(pillCls('more'), isSidebarOpen ? (0, _utils.cn)("bg-gray-100 text-gray-700", hoveredPill === 'more' && "bg-gray-200") : (0, _utils.cn)("text-gray-600", hoveredPill === 'more' && "bg-[var(--primary)]/10")),
            "aria-label": "More",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _Menu.default,
              alt: "",
              className: "w-4 h-4 flex-none pointer-events-none transition-[filter] duration-200",
              style: {
                filter: "brightness(0)"
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: labelCls('more'),
              children: "More"
            })]
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onMouseEnter: expandNav,
          className: (0, _utils.cn)("relative flex items-center justify-center", "h-8 w-8 rounded-full cursor-pointer overflow-hidden whitespace-nowrap", "transition-[background-color] duration-300 ease-out", "focus:outline-none focus:ring-2 focus:ring-[var(--primary)]", activeSection === "chat" ? "bg-[var(--primary)] hover:bg-[var(--background-primary-hover)]" : activeSection === "more" ? "bg-gray-100 hover:bg-gray-200" : "bg-[var(--primary)] hover:bg-[var(--background-primary-hover)]"),
          "aria-label": "".concat(activeSectionLabel, " \u2014 tap to expand navigation"),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: activeSectionIcon,
            alt: "",
            className: "w-4 h-4 flex-none pointer-events-none",
            style: {
              filter: activeSection !== "more" ? "brightness(0) invert(1)" : "brightness(0)"
            }
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_navigationDrawer.NavigationDrawer, {
      isOpen: isSidebarOpen,
      onClose: function onClose() {
        return setIsSidebarOpen(false);
      },
      "data-sentry-element": "NavigationDrawer",
      "data-sentry-source-file": "BottomToolbar.tsx"
    })]
  });
};